import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ConsultaFormContainer from "../../../components/ConsultaFormContainer/ConsultaFormContainer";
import Container from "../../../components/Container/Container";
import SearchContainer from "../../../components/SearchContainer/SearchContainer";
import SearchInput from "../../../components/SearchInput/SearchInput";
import { useListManager } from "../../../contexts/list.manager";
import FormOperadores from "../FormOperadores/FormOperadores";
import ListOperadores from "../ListOperadores/ListOperadores";
import "./ConsultaOperadores.css";
import Button from "../../../components/Button/Button";
import { LuUserPlus, LuUser } from "react-icons/lu";
import Convidar from "../Convidar/Convidar";
import { useAuth } from "../../../contexts/auth";
import { RoleSelector } from "../RoleSelector/RoleSelector";

const ConsultaOperadores = () => {
	const { user, can } = useAuth();
	const { lineSelected } = useListManager();
	const [searchText, setSearchText] = useState("");
	const [filters, setFilters] = useState("");
	const navigate = useNavigate();
	const location = useLocation();
	const [refreshKey, setRefreshKey] = useState(0);
	const [modalInviteIsOpen, setModalInviteIsOpen] = useState(false);
	const [modalIsOpen, setModalIsOpen] = useState(false);

	useEffect(() => {
		if (location.state?.deletedId || location.state?.refresh) {
			setRefreshKey((k) => !k);
			navigate(location.pathname, { replace: true, state: {} });
		}
	}, [location.state, navigate, location.pathname]);

	return (
		<div className="consulta-container">
			<div className="search-list-wrapper">
				<SearchContainer
					icon={<LuUser size={20} />}
					title="Pessoas"
					navigate="../cadastro-operadores"
					description="Buscar por Nome"
					hideAddButton={true}
					aditionalButton1={
						can('bravas.identity.person.invite') &&
						<Button
							className="button-white"
							icon={<LuUserPlus />}
							label="Convidar"
							onClick={() => { setModalInviteIsOpen(true) }}
						/>
					}
					aditionalButton2={
						<RoleSelector />
					}
				>
					<SearchInput
						value={searchText}
						placeholder="Buscar Pessoa"
						onChange={({ target }) => setSearchText(target.value)}
						onKeyPress={(e) => e.key === "Enter" && setFilters(searchText)}
					/>
				</SearchContainer>
				<Container>
					<ListOperadores filters={filters} refreshKey={refreshKey} />
				</Container>
			</div>
			<ConsultaFormContainer>
				<FormOperadores operador={lineSelected} type="consulta" />
			</ConsultaFormContainer>
			<Convidar modalIsOpen={modalInviteIsOpen} handleCancel={setModalInviteIsOpen} />
		</div>
	);
};

export default ConsultaOperadores;
